import { Injectable } from '@angular/core';
import { generateGuid, ItemBase } from '@src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { ModifierSetBase } from '@src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifersetbase';
import { ModifierSetOptionBase } from '@src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-modifieroptionbase';
import { VariantBase } from '@src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-variantbase';
import { Discount } from '@src/app/ecom-models/discount';
import { EcomSettingService } from '@src/app/ecom-services/ecom-setting.service';

@Injectable({
    providedIn: 'root'
})
export class EcomDetailService {
    serviceType: string;

    constructor(private settingService: EcomSettingService) {
        this.settingService.currentCompanySetting.subscribe(setting => {
            if (!setting) return;

            this.serviceType = setting.serviceType;
        });
    }

    createCombo(items: ItemBase[], quantity: number, discount: Discount) {
        const item1 = items[0];
        const discountAmountItem1 = this.calculateDiscountAmount(item1.priceEach, discount);
        if (items.length === 1) {
            if (quantity === 1) {
                // Case 1: Quantity 1, 1 item in array
                return [
                    {
                        optionName: 'Special deal',
                        description: `1 x ${item1.itemName}`,
                        originalPrice: 1 * item1.priceEach,
                        salePrice: (1 * item1.priceEach) - (1 * discountAmountItem1),
                        itemsToAdd: [item1.itemGuid]
                    }
                ];
            }
            if (quantity === 2) {
                // Case 2: Quantity 2, 1 item in array
                return [
                    {
                        optionName: 'Special deal',
                        description: `2 x ${item1.itemName}`,
                        originalPrice: 2 * item1.priceEach,
                        salePrice: (2 * item1.priceEach) - (2 * discountAmountItem1),
                        itemsToAdd: [item1.itemGuid, item1.itemGuid]
                    }
                ];
            }
        }

        if (items.length === 2) {

            if (quantity === 2) {
                // Case 1: Quantity 2, 2 items in array
                const item2 = items[1];
                const discountAmountItem2 = this.calculateDiscountAmount(item2.priceEach, discount);
                return [
                    {
                        optionName: 'OPTION 1',
                        description: `2 x ${item1.itemName}`,
                        originalPrice: 2 * item1.priceEach,
                        salePrice: (2 * item1.priceEach) - (2 * discountAmountItem1),
                        itemsToAdd: [item1.itemGuid, item1.itemGuid]
                    },
                    {
                        optionName: 'OPTION 2',
                        description: `2 x ${item2.itemName}`,
                        originalPrice: 2 * item2.priceEach,
                        salePrice: (2 * item2.priceEach) - (2 * discountAmountItem2),
                        itemsToAdd: [item2.itemGuid, item2.itemGuid]
                    },
                    {
                        optionName: 'OPTION 3',
                        description: `1 x ${item1.itemName}<br>1 x ${item2.itemName}`,
                        originalPrice: item1.priceEach + item2.priceEach,
                        salePrice: item1.priceEach + item2.priceEach - discountAmountItem1 - discountAmountItem2,
                        itemsToAdd: [item1.itemGuid, item2.itemGuid]
                    }
                ];
            } else if (quantity === 1) {
                // Case 2: Quantity 1, 2 items in array
                return [
                    {
                        optionName: 'Special deal',
                        description: `2 x ${item1.itemName}`,
                        originalPrice: 2 * item1.priceEach,
                        salePrice: (2 * item1.priceEach) - discountAmountItem1,
                        itemsToAdd: [item1.itemGuid, item1.itemGuid]
                    }
                ];
            }
        }
        // Return empty if conditions do not match
        return [];
    }

    createComboBuyGet(items: ItemBase[], quantity: number, discount: Discount) {
        const item1 = items[0];
        if (items.length === 1) {
            if (quantity === 1) {

                return [
                    {
                        optionName: 'Special deal',
                        description: `${quantity} x ${item1.itemName}`,
                        originalPrice: quantity * item1.priceEach,
                        salePrice: 0,
                        itemsToAdd: [item1.itemGuid]
                    }
                ];
            }

            if (quantity === 2) {

                return [
                    {
                        optionName: 'Special deal',
                        description: `${quantity} x ${item1.itemName}`,
                        originalPrice: quantity * item1.priceEach,
                        salePrice: 0,
                        itemsToAdd: [item1.itemGuid, item1.itemGuid]
                    }
                ];
            }
        }

        if (items.length === 2) {

            if (quantity === 2) {
                // Case 1: Quantity 2, 2 items in array
                const item2 = items[1];

                return [
                    {
                        optionName: 'OPTION 1',
                        description: `${quantity} x ${item1.itemName}`,
                        originalPrice: quantity * item1.priceEach,
                        salePrice: 0,
                        itemsToAdd: [item1.itemGuid, item1.itemGuid]
                    },
                    {
                        optionName: 'OPTION 2',
                        description: `${quantity} x ${item2.itemName}`,
                        originalPrice: quantity * item2.priceEach,
                        salePrice: 0,
                        itemsToAdd: [item2.itemGuid, item2.itemGuid]
                    },
                    {
                        optionName: 'OPTION 3',
                        description: `1 x ${item1.itemName}<br>1 x ${item2.itemName}`,
                        originalPrice: item1.priceEach + item2.priceEach,
                        salePrice: 0,
                        itemsToAdd: [item1.itemGuid, item2.itemGuid]
                    }
                ];
            } else if (quantity === 1) {
                // Case 2: Quantity 1, 2 items in array
                const item2 = items[1];
                return [
                    {
                        optionName: 'OPTION 1',
                        description: `1 x ${item1.itemName}`,
                        originalPrice: item1.priceEach,
                        salePrice: 0,
                        itemsToAdd: [item1.itemGuid]
                    },
                    {
                        optionName: 'OPTION 2',
                        description: `${quantity} x ${item2.itemName}`,
                        originalPrice: item2.priceEach,
                        salePrice: 0,
                        itemsToAdd: [item2.itemGuid]
                    },
                ];
            }
        }
        // Return empty if conditions do not match
        return [];
    }

    calculateDiscountAmount(priceEach: number, discount: Discount) {
        const discountValue = discount.discount_value;
        let discountType = discount.discount_value_type;
        if (discount.discount_primary_type === 'FIXED_AMOUNT') {
            discountType = "FIXED_AMOUNT";
        }
        if (discountType === "PERCENTAGE") {
            const discountRate = discountValue / 100;
            return priceEach * discountRate;
        }
        if (discountType === "AMOUNT") {
            return discountValue;
        }
        if (discountType === "FIXED_AMOUNT") {
            return priceEach - discountValue;
        }
        return 0;
    }

    // Function to merge cart items, group items with the same criteria, and sum their quantities
    mergeCartItems(cart: ItemBase[]) {
        let mergedCart: ItemBase[] = [];

        cart.forEach(item => {
            // Check if an existing item already exists in the merged cart
            // The condition checks two cases:
            // 1. Item doesn't have a modifier: compare by itemGuid and iuic_pkid
            // 2. Item has a modifier: compare by itemModId and iuic_pkid
            let existingItem = mergedCart.find(x => (!x.HasModifier && x.itemGuid === item.itemGuid && x.iuic_pkid === item.iuic_pkid)
                || ((x.HasModifier && x.itemModId === item.itemModId && x.iuic_pkid === item.iuic_pkid)));

            if (existingItem) {
                // If an existing item is found, update its quantity by adding the current item's quantity
                existingItem.quantity += item.quantity;
            } else {
                mergedCart.push({ ...item });
            }
        });

        return mergedCart;
    }


    splitItemByDiscount(item, maxDiscountUses, discount: Discount) {
        const discountedQty = Math.min(item.quantity, maxDiscountUses);
        const nonDiscountedQty = item.quantity - discountedQty;

        let discountedItems: ItemBase[] = [];
        let nonDiscountedItem: ItemBase;

        if (discountedQty > 0) {
            for (let i = 0; i < discountedQty; i++) {
                discountedItems.push({
                    ...item,
                    quantity: 1,
                    guid: generateGuid(),
                    selectedDiscountId: discount.discount_pkid,
                    discounted: true,
                    iuic_pkid: 0,
                    modifierSetList: item.modifierSetList.map(modifierSet => ({
                        ...modifierSet,
                        modifierGuid: generateGuid(),
                        modifierOptions: modifierSet.modifierOptions.map(modifierOption => ({
                            ...modifierOption,
                            optionGuid: generateGuid()
                        }))
                    }))
                });
            }
        }

        if (nonDiscountedQty > 0) {
            nonDiscountedItem = {
                ...item,
                iuic_pkid: 0,
                quantity: nonDiscountedQty,
                guid: generateGuid(),
                modifierSetList: item.modifierSetList.map(modifierSet => ({
                    ...modifierSet,
                    modifierGuid: generateGuid(),
                    modifierOptions: modifierSet.modifierOptions.map(modifierOption => ({
                        ...modifierOption,
                        optionGuid: generateGuid()
                    }))
                }))
            };
        }

        return { discountedItems, nonDiscountedItem };
    }

    mapItemBase(item) {
        
        const itemDetails = new ItemBase({
            itemGuid: item.item_pkid,
            itemName: item.item_name,
            itemAlternativeName: item.item_alternative_name,
            itemDescription: item.item_description,
            imagePath: item.item_image,
            imageColor: item.item_color,
            isValid: true,
            HasModifier: item.HasModifiers,
            has_discount: item.iscvsd_has_discount,
            iscvsd_pkid: item.iscvsd_pkid
        });

        if (item.HasModifiers) {
            itemDetails.itemModId = `${item.item_pkid}-${item.iscvsd_pkid}`;
        }

        itemDetails.discounts = item.discounts && item.discounts.map(x => new Discount(x));


        //const taxtype = this.settings.company_sell_price_tax;

        const tax = item.mm_items_standard_composite_variant_service_details.length > 0 && item.mm_items_standard_composite_variant_service_details[0].mm_taxes;
        if (tax) {
            itemDetails.tax = tax;
        }
        // variants
        item.mm_items_standard_composite_variant_service_details.forEach(element => {
            const taxRate = element.mm_taxes.tax_rate;
            let dineInPrice = element.online_order_item_pricing.ooip_price_value;
            let deliveryCollectionPrice = element.online_order_item_pricing.ooip_price_value;
            let dineInPriceDiscounted = element.online_order_item_pricing.ooip_dinein_discount_price_value;
            let collectionPriceDiscounted = element.online_order_item_pricing.ooip_collection_delivery_discount_price_value;
            let deliveryPriceDiscounted = element.online_order_item_pricing.ooip_delivery_discount_price_value;
            //taxAmountDineIn = this.calculateTax(taxtype === 'TAX_IN' ? 'TAX_IN' : 'TAX_EX', dineInPriceDiscounted > 0 ? dineInPriceDiscounted : dineInPrice, taxRate);

            const variant = new VariantBase({
                variant_oadp: element.online_order_item_pricing.ooip_oadp,
                variantGuid: element.iscvsd_pkid,
                variantName: element.iscvsd_name,
                variantAlternativeName: element.iscvsd_alternative_name,
                variantDineInPrice: Number(Number(dineInPrice).toFixed(2)),
                variantDeliveryCollectionPrice: Number(Number(deliveryCollectionPrice).toFixed(2)),
                variantDineInPriceDiscounted: Number(Number(dineInPriceDiscounted).toFixed(2)),
                variantCollectionPriceDiscounted: Number(Number(collectionPriceDiscounted).toFixed(2)),
                variantDeliveryPriceDiscounted: Number(Number(deliveryPriceDiscounted).toFixed(2)),
                variantMaxPerOrder: element.online_order_item_pricing.ooip_max_per_order,
                variantMaxPerDay: element.online_order_item_pricing.ooip_max_per_day,
                selected: false,
                variantTaxGuid: element.mm_taxes.tax_guid,
                variantTaxRate: taxRate,
                variantAvailable: element.online_order_item_pricing.ooip_is_active && element.online_order_item_pricing.availableForSelctedDateTime,
                variantSKU: element.iscvsd_sku,
                outofstock: element.outofstock
            });
            itemDetails.variantList.push(variant);
        });
        // modifiers
        item.mm_items_modifier_mappings.forEach(element => {

            const modifier = new ModifierSetBase({
                modifiermappingGuid: element.imm_guid,
                modifierGuid: element.imm_modifier_guid,
                modifierName: element.modifier_name,
                modifierCaption: element.modifier_caption,
                modifierSetMin: element.imm_modifier_minimum,
                modifierSetMax: element.imm_modifier_maximum,
                modifierOptions: [],
                collapsed: false,
                quantity: 0,
            });

            //modifier.selectedOptions = [];
            const modifierOptions = [];
            element.mm_items_modifier_mapping_options.forEach(option => {
                let modifierOptionPrice = option.mm_items_modifier_options.modifier_option_price;
                const modifierTaxRate = option.mm_items_modifier_options.mm_taxes.tax_rate;

                let modifierTax = 0;

                let optionData = this.ModifierSetOptionMapData(option, modifierTaxRate, modifierTax, modifier);

                if (option.mm_items_modifier_options.modifiers_into_modifier.length) {

                    const modifiers_into_modifier = option.mm_items_modifier_options.modifiers_into_modifier.map(x => this.ModifierSetOptionMapData(x, modifierTaxRate, modifierTax, modifier, true));
                    optionData = { ...optionData, modifiers_into_modifier: modifiers_into_modifier }
                }
                modifierOptions.push(optionData);
            });
            // sort by price
            //modifierOptions.sort((a, b) => a.optionPrice < b.optionPrice ? -1 : a.optionPrice > b.optionPrice ? 1 : 0);
            modifier.modifierOptions = modifierOptions;
            itemDetails.modifierSetList.push(modifier);
        });

        this.setDefaults2(itemDetails);
        return itemDetails;
    }
    setDefaults2(item, quantity?: number) {
        if (!item.variantList.length) return;


        item.variantList[0].selected = true;
        item.variantList[0].variantQty = quantity !== undefined ? quantity : 1;
        item.priceEach = item.variantList[0].variantDineInPriceDiscounted ? item.variantList[0].variantDineInPriceDiscounted : item.variantList[0].variantDineInPrice;

        item.modifierSetList.forEach(modifier => {
            modifier.modifierOptions.forEach(option => {
                if (option.optionPreSelected) {
                    const price = option.optionDineInPriceDiscounted > 0 ? option.optionDineInPriceDiscounted : option.optionDineInPrice;

                    //item.priceEachAfterDiscount = item.priceEachAfterDiscount + option.optionDineInPriceDiscounted;
                    //item.priceEachBeforeDiscount = item.priceEachBeforeDiscount + option.optionDineInPrice;
                    item.priceEach = price;
                    //item.taxEach = item.taxEach + option.optionTaxAmtDineIn;

                    // if (this.serviceType === 'COLLECTION') {
                    //   const price = option.optionCollectionPriceDiscounted > 0 ? option.optionCollectionPriceDiscounted : option.optionCollectionPrice;


                    //   item.priceEach = price;
                    // }
                }
            });
        });

        item.quantity = 1;
        // update the total price
        item.totalPrice = item.variantList[0].variantQty * item.priceEach;
    }
    ModifierSetOptionMapData(option, modifierTaxRate, modifierTax, modifier, modifiers_into_modifier = false) {
        const modiferOption = new ModifierSetOptionBase({
            has_modifiers_into_modifier: modifiers_into_modifier,
            option_oadp: option.option_oadp,
            optionGuid: option.immo_guid,
            optionPkid: option.immo_pkid,
            option_pkid: option.immo_modifier_option_pkid,
            optionName: option.mm_items_modifier_options.modifier_option_name,
            imm_item_pkid: option.mm_items_modifier_options.imm_item_pkid
        });

        const { dinein_discount_price_value } = option;
        modiferOption.optionPrice = dinein_discount_price_value > 0 ? dinein_discount_price_value : option.mm_items_modifier_options.modifier_option_price;
        // if (this.serviceType === "COLLECTION") {
        //   modiferOption.optionPrice = collection_delivery_discount_price_value > 0 ? collection_delivery_discount_price_value : option_collection_price;
        // }
        modiferOption.optionPreSelected = option.immo_preselect;
        modiferOption.optionQuantity = 0;
        modiferOption.optionTaxRate = modifierTaxRate;
        modiferOption.optionTaxAmt = Number(modifierTax.toFixed(2));
        modiferOption.optionTaxGuid = option.mm_items_modifier_options.mm_taxes.tax_guid;
        modiferOption.optionSelected = option.immo_preselect;
        if (modiferOption.optionPreSelected) {
            modiferOption.optionQuantity = 1;
            modifier.quantity = modifier.quantity + 1;
            modifier.modifierSetSelected = true;
        }
        //option price discounted and actual 
        modiferOption.optionDineInPrice = option.option_dinein_price;
        modiferOption.optionDineInPriceDiscounted = option.option_dinein_price_discounted;
        modiferOption.optionCollectionPrice = option.option_collection_price;
        modiferOption.optionCollectionPriceDiscounted = option.option_collection_price_discounted;
        modiferOption.tax = option.mm_items_modifier_options.mm_taxes;
        // modiferOption.optionDeliveryPrice = option.option_delivery_price;
        // modiferOption.optionDeliveryPriceDiscounted = option.option_delivery_price_discounted;

        // no need to add the tax   

        return modiferOption;
    }



}
